import React, { useCallback, useState } from 'react';
import { Stacker, TypographyBody, Chip, ImageBase, Skeleton } from '@honeycomb/ui-core';
import { useGlobalContext, usePrevious } from '@honeycomb/data';
import { getDuration } from '../../../../utils/date-utils';
import { getStops } from '../../../flight/utils/utils';
export function FlightSummaryLeg({ leg, waiting = false }) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    const { resourceStrings: { HC_AIRLINELOGOBASEURL, HC_DIRECT, HCSTOPS, HC_STOP }, } = useGlobalContext();
    const imageName = (_c = (_b = (_a = leg === null || leg === void 0 ? void 0 : leg.segments) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.airline) === null || _c === void 0 ? void 0 : _c.imageName;
    const logoUrl = imageName ? HC_AIRLINELOGOBASEURL + imageName : '';
    const prevLogoUrl = usePrevious(logoUrl);
    const [imageError, setImageError] = useState(false);
    if (logoUrl !== prevLogoUrl && imageError) {
        setImageError(false);
    }
    const onImageError = useCallback(() => {
        setImageError(true);
    }, [setImageError]);
    if (waiting || !leg) {
        return (React.createElement(Stacker, { spacing: 1 },
            React.createElement(Stacker, { direction: "row", justifyContent: "space-between" },
                React.createElement(TypographyBody, { component: "div" },
                    React.createElement(Skeleton, { variant: "text", w: 100 })),
                React.createElement(Skeleton, { w: 60, h: 24, radius: 5 })),
            React.createElement("div", null,
                React.createElement(Skeleton, { variant: "text", w: 240 })),
            React.createElement(TypographyBody, { component: "div", size: "xs" },
                React.createElement(Skeleton, { variant: "text", w: 50 }))));
    }
    const { departureDateTime, arrivalDateTime, dayDifference, segments, stops, duration } = leg;
    const departureAirport = (_e = (_d = segments === null || segments === void 0 ? void 0 : segments[0]) === null || _d === void 0 ? void 0 : _d.departureAirport) === null || _e === void 0 ? void 0 : _e.title;
    const arrivalAirport = (_g = (_f = segments === null || segments === void 0 ? void 0 : segments[segments.length - 1]) === null || _f === void 0 ? void 0 : _f.arrivalAirport) === null || _g === void 0 ? void 0 : _g.title;
    const cabinClass = (_h = segments === null || segments === void 0 ? void 0 : segments[0]) === null || _h === void 0 ? void 0 : _h.cabinClass;
    const airlineName = (_l = (_k = (_j = segments === null || segments === void 0 ? void 0 : segments[0]) === null || _j === void 0 ? void 0 : _j.airline) === null || _k === void 0 ? void 0 : _k.name) !== null && _l !== void 0 ? _l : '';
    return (React.createElement(Stacker, { spacing: 1 },
        React.createElement(Stacker, { justifyContent: "space-between", direction: "row" },
            React.createElement(TypographyBody, { color: "text.heading", size: "m", weight: "bold" }, departureDateTime === null || departureDateTime === void 0 ? void 0 :
                departureDateTime.time,
                " - ", arrivalDateTime === null || arrivalDateTime === void 0 ? void 0 :
                arrivalDateTime.time,
                dayDifference > 0 ? `  (+${dayDifference})` : ''),
            logoUrl && !imageError && (React.createElement(ImageBase, { disableLazy: true, onImageError: onImageError, w: 60, h: 24, overflow: "hidden", "data-id": "flight_details_segment_airline_logo", alt: airlineName, src: logoUrl })),
            logoUrl && imageError && React.createElement(TypographyBody, null, airlineName)),
        departureAirport && arrivalAirport && (React.createElement(TypographyBody, { size: "m" },
            departureAirport,
            " to ",
            arrivalAirport)),
        React.createElement(Stacker, { spacing: 2, direction: "row", alignItems: "center" },
            React.createElement(TypographyBody, { size: "s", weight: "semiBold" }, `${getStops(stops, { HC_DIRECT, HCSTOPS, HC_STOP })}, `),
            React.createElement(TypographyBody, { size: "s" }, getDuration(duration)),
            cabinClass && (React.createElement(Chip, { size: "xs", color: "neutral" }, cabinClass)))));
}
